import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './assets/locales/en.json';
import es from './assets/locales/es.json';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'es',
  messages: { en, es },
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js